<div class="page-container">
    <div class="d-flex align-items-center mb-4">
        <span class="me-2 fs-4">&larr;</span>
        <h4 class="back-title mb-0">Bulk Student Outing</h4>
    </div>
    <div class="row g-4 mb-4">
        <div class="col-md-6">
            <label class="form-label text-muted">Select Section</label>

            <div class="dropdown w-100">
                <button class="btn btn-outline-secondary dropdown-toggle w-100 d-flex align-items-center" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" (click)="focusSearchcampusInput()">

                    <span>{{ selectedSectionName || 'Select Section' }}</span>
                </button>

                <ul class="dropdown-menu w-100 campus-details">
                    <!-- Search -->
                    <li class="px-2 py-1">
                        <input type="text" class="form-control " placeholder="Search Section" [(ngModel)]="sectionQuery"
                            (keyup)="filterSections()" #searchInputsection>
                    </li>

                    <!-- List -->
                    <li class="list_campus">
                        <ng-container *ngFor="let sec of filteredSections">
                            <ul class="overall_Detail" (click)="selectSection(sec)"
                                [class.selected]="selectedSectionId === sec.sectionId">

                                <li class="campus_right">
                                    {{ sec.sectionName }}
                                </li>

                                <li>
                                    <i *ngIf="selectedSectionId === sec.sectionId" class="fa fa-check right_check"></i>
                                </li>

                            </ul>
                        </ng-container>
                    </li>
                </ul>
            </div>
        </div>

        <div class="col-md-6">
            <label class="form-label text-muted">Search by Admission</label>
            <input class="form-control custom-input" type="text" placeholder="Enter" [(ngModel)]="admissionSearch">
        </div>
    </div>
    <div class="card-box mb-4">

        <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="d-flex align-items-center gap-2">
                <label>Show</label>
                <select class="form-select page-size-select" [(ngModel)]="pageSize">
                    <option [value]="25">25</option>
                    <option [value]="50">50</option>
                    <option [value]="100">100</option>
                </select>
            </div>

            <div style="width:250px;">
                <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchText">
            </div>
        </div>
        <ag-grid-angular class="ag-theme-alpine w-100 ag-grid-height" [columnDefs]="columnDefs" [rowData]="rowData"
            [suppressRowClickSelection]="true" [gridOptions]="gridOptions" rowSelection="multiple"
            (gridReady)="onGridReady($event)" [animateRows]="true" (selectionChanged)="onSelectionChanged()">
        </ag-grid-angular>
    </div>
    <h1 class="fw-bold mb-2">Outing Details</h1>
    <div class="card-box">
        <p class="fw-semibold fs-6 mb-4">
            Total Student Outing :
            <span class="text-primary fw-bold">{{ totalStudentOuting }}</span>
        </p>

        <div class="row g-4">

            <div class="col-md-4">
                <label class="form-label text-muted">Reason for Outing</label>

                <select class="form-select" [(ngModel)]="reasonForOuting">
                    <option value="">Select</option>

                    <option *ngFor="let item of outinglistdata" [value]="item.reasonId">
                        {{ item.reason }}
                    </option>
                </select>
            </div>

            <div class="col-md-4">
                <label class="form-label text-muted">Out Time</label>
                <input class="form-control" type="datetime-local" placeholder="dd-mm-yyyy  ...  :  ..."
                    [(ngModel)]="outTime">
            </div>

            <div class="col-md-4">
                <label class="form-label text-muted">In Time</label>
                <input class="form-control" type="datetime-local" placeholder="dd-mm-yyyy  ...  :  ..."
                    [(ngModel)]="inTime">
            </div>

            <div class="col-12">
                <label class="form-label text-muted">Remarks</label>
                <textarea class="form-control" placeholder="Enter your remarks" [(ngModel)]="remarks"></textarea>
            </div>

        </div>
    </div>

    <!-- SUBMIT BUTTON -->
    <div class="text-center mt-4 mb-3">
        <button class="btn btn-submit" (click)="onSubmitBulkRequest()" [disabled]="totalStudentOuting === 0">
            Submit Bulk Request
        </button>
    </div>

</div>